import React from 'react';
import './request info.css'
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { Spin, Button } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { hasValue } from "../../validations/validations";
import { ActionCardContent, MainCardContent, ModalForUpdateStatus, SuggestedAdvertisementsTable } from './requestInfoDesign';
import { deleteApi, getRequestHistoryApi, getSuggestedAdvertisementsApi, updateStatusApi } from './requestInfoApi';
class requestInfo extends React.Component {
  state = {
    actionType: this.props.location.state.actionType ? this.props.location.state.actionType === "EDIT" ? "EDIT" : "VIEW" : "VIEW",
    page: 1,
    pages: 1,
    id: this.props.location.state.data.id ? this.props.location.state.data.id : null,
    status: this.props.location.state.data.status ? this.props.location.state.data.status : "",
    category: this.props.location.state.data.category ? this.props.location.state.data.category.categoryName : "",
    subCategory: this.props.location.state.data.subCategory ? this.props.location.state.data.subCategory.categoryName : "",
    area: this.props.location.state.data.area ? this.props.location.state.data.area.areaName : "",
    city: this.props.location.state.data.city ? this.props.location.state.data.city.cityName : "",
    priceFrom: this.props.location.state.data.priceFrom ? this.props.location.state.data.priceFrom : "",
    priceTo: this.props.location.state.data.priceTo ? this.props.location.state.data.priceTo : "",
    bedrooms: this.props.location.state.data.bedrooms ? this.props.location.state.data.bedrooms : null,
    notes: this.props.location.state.data.notes ? this.props.location.state.data.notes : "",
    user: this.props.location.state.data.user ? this.props.location.state.data.user : [],
    phone: this.props.location.state.data.phone ? this.props.location.state.data.phone : "",
    fullname: this.props.location.state.data.fullname ? this.props.location.state.data.fullname : "",
    actionUser: this.props.location.state.data.actionUser ? this.props.location.state.data.actionUser : null,
    clientType: this.props.location.state.data.clientType ? this.props.location.state.data.clientType : '',
    clientStatus: this.props.location.state.data.clientStatus ? this.props.location.state.data.clientStatus : '',
    rate: this.props.location.state.data.rate ? this.props.location.state.data.rate : null,
    firstHousing: this.props.location.state.data.firstHousing ? this.props.location.state.data.firstHousing : null,
    categories: [],
    subCategories: [],
    cities: [],
    areas: [],
    loading: false,
    modal: false,
    suggestedAdvertisements: [],
    requestsSearchData: null,
    requestHistory: [],
    projects: [],
    currentProject: this.props.location.state.data.currentProject ? this.props.location.state.data.currentProject : null,
  };

  constructor(props) {
    super(props)
    window.scrollTo(0, 0)
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }
  componentDidMount() {
    if (sessionStorage.getItem('requestsSearchData')) {
      let requestsSearchData = sessionStorage.getItem('requestsSearchData');
      if (requestsSearchData != '{}') this.setState({ requestsSearchData: requestsSearchData })
    }
    this.getCategory()
    this.getCities(1)
    this.getProjects()
    this.getRequestHistory(this.props.location.state.data.id)
    this.getSuggestedAdvertisements(1, this.state.id)
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }
  getProjects = () => {
    axios.get(`${BASE_END_POINT}projects/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ projects: response.data.data })
      })
      .catch(error => {
        console.log("ALL projects ERROR")
        console.log(error.response)
      })
  }
  getCities = (country) => {
    axios.get(`${BASE_END_POINT}countries/1/cities/withoutPagenation/get?country=${country}`)
      .then(response => {
        console.log('cities  ', response.data)
        this.setState({ cities: response.data.data })
      })
      .catch(error => {
        console.log('cities ERROR  ', error)
        console.log('cities ERROR  ', error.respose)
      })
  }
  getAreas = (city) => {
    axios.get(`${BASE_END_POINT}areas/${city}/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ areas: response.data.data })
      })
      .catch(error => {
        console.log("ALL areas ERROR")
        console.log(error.response)
      })
  }
  getCategory = () => {
    axios.get(`${BASE_END_POINT}categories`)
      .then(response => {
        console.log(response.data)
        this.setState({ categories: response.data.data })
      })
      .catch(error => {
        console.log("ALL categories ERROR")
        console.log(error.response)
      })
  }
  getSubCategory = (category) => {
    axios.get(`${BASE_END_POINT}categories/${category}/sub-categories`)
      .then(response => {
        console.log(response.data)
        this.setState({ subCategories: response.data.data })
      })
      .catch(error => {
        console.log("ALL subCategories ERROR")
        console.log(error.response)
      })
  }
  getRequestHistory = async (id) => {
    try {
      const data = await getRequestHistoryApi(id, this.props.currentUser.token, this.props.isRTL);
      this.setState({ requestHistory: data.data });
    } catch (error) {
      console.log('get request History ERROR ', error);
    }
  };
  getSuggestedAdvertisements = async (page, id) => {
    try {
      const data = await getSuggestedAdvertisementsApi(page, id, this.props.currentUser.token, this.props.isRTL);
      console.log('getSuggestedAdvertisements ', data);
      this.setState({
        suggestedAdvertisements: data.data,
        pages: data.pageCount,
        page: data.page,
        loading: false,
      });
    } catch (error) {
      console.log('getSuggestedAdvertisements ERROR ', error);
    }
  };
  delete = async () => {
    try {
      await deleteApi(this.props.location.state.data.id, this.props.currentUser.token, this.props.isRTL, allStrings);
      console.log("request DELETED");
      this.props.history.goBack();
    } catch (error) {
      console.log("delete ", error);
    }
  };
  updateStatus = async () => {
    const { clientType, clientStatus, notes, id } = this.state;
    if (hasValue(notes) && clientType != null && clientStatus != null) {
      try {
        let response = await updateStatusApi(id, this.state, this.props.currentUser.token, this.props.isRTL, allStrings);
        if (response.success) {
          this.getRequestHistory(id)
          this.setState({ modal: false })
        }

      } catch (error) {
        console.log("update status ", error);
      }
    }
  };
  changeHandler = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  handleChangeState = (fieldName, value) => {
    this.setState({ [fieldName]: value });
  };
  submitHandler = (event) => {
    event.preventDefault();
    event.target.className += " was-validated";
    this.updateStatus()
  };
  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  }
  render() {
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('REQUESTS')) return <Redirect to='/Home' />
    return (
      <div className="App">
        <Spin spinning={this.state.loading} tip={allStrings.loading} size="large" style={{ color: '#1D9598' }}>
          <MDBContainer>
            <ModalForUpdateStatus
              isOpen={this.state.modal}
              toggle={this.toggle}
              submitHandler={this.submitHandler}
              changeHandler={this.changeHandler}
              state={this.state}
              isRTL={this.props.isRTL}
              allStrings={allStrings}
              getAreas={this.getAreas}
              getSubCategory={this.getSubCategory}
              handleChangeState={this.handleChangeState}
            />
            <MDBRow style={{ textAlign: this.props.isRTL ? 'right' : 'left' }}>
              <MDBCol md="12">
                <Button
                  dir={this.props.isRTL ? 'rtl' : 'ltr'}
                  onClick={() => { this.props.history.push("requests", { requestsSearchData: JSON.parse(this.state.requestsSearchData) }) }}
                  icon={<ArrowRightOutlined />}
                  style={{
                    background: "linear-gradient(90deg, #1D9598, #127275)", color: "white",
                    border: "none", borderRadius: "12px", fontWeight: "500",
                    padding: "0 16px", height: "40px", transition: "all 0.5s ease-in-out"
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.background = "linear-gradient(90deg, #127275, #1D9598)" }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = "linear-gradient(90deg, #1D9598, #127275)" }}
                >
                  {allStrings.back}
                </Button>
              </MDBCol>
            </MDBRow>
            <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
              <MDBCol lg="5" md='12'>
                <div className="infoCard">
                  <Card className="editCard" style={{ overflow: 'visible', outline: 'none', marginBottom: '0px' }}>
                    <CardMedia style={{ height: "0px" }} />
                    <CardHeader></CardHeader>
                    <div style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row', display: 'flex' }}>
                      <div className="topIcon" style={{ background: 'linear-gradient(135deg, #1D9598, #127275)' }}>
                        <span class="material-icons" style={{ color: 'white', fontSize: 20 }}>featured_video</span>
                      </div>
                      <div className="tableTitle" style={{ display: 'inline-block', marginTop: '-60px', marginLeft: '0', marginRight: '0' }}>
                        <p></p>
                      </div>
                    </div>
                    <MainCardContent
                      state={this.state}
                      isRTL={this.props.isRTL}
                      allStrings={allStrings}
                      history={this.props.history}
                      currentUser={this.props.currentUser}
                      deleteRequest={this.delete}
                      toggle={this.toggle}
                    />
                  </Card>
                </div>
              </MDBCol>
              <ActionCardContent
                state={this.state}
                isRTL={this.props.isRTL}
                allStrings={allStrings}
                history={this.props.history}
                changeHandler={this.changeHandler}
              />
            </MDBRow>
            {this.state.actionType === "VIEW" &&
              <SuggestedAdvertisementsTable
                allStrings={allStrings}
                state={this.state}
                isRTL={this.props.isRTL}
                history={this.props.history}
                getSuggestedClients={this.getSuggestedAdvertisements}
                setPage={(page) => this.setState({ page: page })}
              />
            }
          </MDBContainer>
        </Spin>
      </div>
    )
  }
}
const mapToStateProps = (state) => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
});
const mapDispatchToProps = {
};
export default withRouter(
  connect(mapToStateProps, mapDispatchToProps)(requestInfo)
);